<template>
    <div class="unfair" v-if="isUnfairList">
        <span v-if="!isAllArchived">
            <span class="unfair__msg">C {{ dateParser(firstActual.unfair_date) }} включён в реестр недобросовестных поставщиков.</span>
            <span @click="modalHandler" class="uk-pseudolink no-print">Предыдущие включения</span>
        </span>
        <span v-if="isAllArchived">
            <span class="unfair__msg">Ранее был включён в </span>
            <span @click="modalHandler" class="uk-pseudolink no-print">реестр недобросовестных поставщиков. </span>
            <span class="unfair__msg">На данный момент исключён из реестра.</span>
        </span>
        <unfair-modal
            v-if="isModal"
            :actualList="actualList"
            :archiveList="archiveList"
            :close="modalHandler" 
        />
    </div>
</template>

<script>
import unfairModal from '@/components/card/shortResume/unfairSupplier/unfairModal.vue'
export default {
    data() {
        return {
            isModal: false
        }
    },
    components: {
        unfairModal
    },
    computed: {
        unfairList() { return this.$store.state?.card?.unfairSupplier?.list },
        isAllArchived() { return this.unfairList.every(e => e.actual !== '1') },
        firstActual() { return this.unfairList.find(e => e.actual === '1') },
        actualList() { return this.unfairList.filter(e => e.actual === '1') },
        archiveList() { return this.unfairList.filter(e => e.actual === '0') },
        isUnfairList() { return this.unfairList?.length }
    },
    methods: {
        modalHandler() { this.isModal = !this.isModal }
    },
    mounted() { this.$store.dispatch('card/getUnfairSupplier') }
}
</script>

<style lang="sass" scoped>
    .unfair
        font-size: 13px
        line-height: 18px
        &__msg
            color: rgb(231, 76, 60)
</style>